var _TopicMapSummary;
import Component from "@glimmer/component";
import { htmlSafe } from "@ember/template";
import { gt } from "truth-helpers";
import DButton from "discourse/components/d-button";
import RelativeDate from "discourse/components/relative-date";
import TopicParticipants from "discourse/components/topic-map/topic-participants";
import number from "discourse/helpers/number";
import slice from "discourse/helpers/slice";
import i18n from "discourse-common/helpers/i18n";
import { avatarImg } from "discourse-common/lib/avatar-utils";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
export default class TopicMapSummary extends Component {
  get linksCount() {
    return this.args.topicDetails.links?.length ?? 0;
  }
  get createdByUsername() {
    return this.args.topicDetails.created_by?.username;
  }
  get lastPosterUsername() {
    return this.args.topicDetails.last_poster?.username;
  }
  get toggleMapButton() {
    return {
      title: this.args.collapsed ? "topic.expand_details" : "topic.collapse_details",
      icon: this.args.collapsed ? "chevron-down" : "chevron-up",
      ariaExpanded: this.args.collapsed ? "false" : "true",
      ariaControls: "topic-map-expanded__aria-controls",
      action: this.args.toggleMap
    };
  }
  get shouldShowParticipants() {
    return this.args.collapsed && this.args.topic.posts_count > 2 && this.args.topicDetails.participants && this.args.topicDetails.participants.length > 0;
  }
  get createdByAvatar() {
    return htmlSafe(avatarImg({
      avatarTemplate: this.args.topicDetails.created_by?.avatar_template,
      size: "tiny",
      title: this.args.topicDetails.created_by?.name || this.args.topicDetails.created_by?.username
    }));
  }
  get lastPostAvatar() {
    return htmlSafe(avatarImg({
      avatarTemplate: this.args.topicDetails.last_poster?.avatar_template,
      size: "tiny",
      title: this.args.topicDetails.last_poster?.name || this.args.topicDetails.last_poster?.username
    }));
  }
}
_TopicMapSummary = TopicMapSummary;
setComponentTemplate(createTemplateFactory(
/*
  
    <nav class="buttons">
      <DButton
        @icon={{this.toggleMapButton.icon}}
        @title={{this.toggleMapButton.title}}
        @ariaExpanded={{this.toggleMapButton.ariaExpanded}}
        @ariaControls={{this.toggleMapButton.ariaControls}}
        @action={{this.toggleMapButton.action}}
        class="btn"
      />
    </nav>
    <ul>
      <li class="created-at">
        <h4 role="presentation">{{i18n "created_lowercase"}}</h4>
        <div class="topic-map-post created-at">
          <a
            class="trigger-user-card"
            data-user-card={{this.createdByUsername}}
            title={{this.createdByUsername}}
            aria-hidden="true"
          />
          {{this.createdByAvatar}}
          <RelativeDate @date={{@topic.created_at}} />
        </div>
      </li>
      <li class="last-reply">
        <a href={{@topic.lastPostUrl}}>
          <h4 role="presentation">{{i18n "last_reply_lowercase"}}</h4>
          <div class="topic-map-post last-reply">
            <a
              class="trigger-user-card"
              data-user-card={{this.lastPosterUsername}}
              title={{this.lastPosterUsername}}
              aria-hidden="true"
            />
            {{this.lastPostAvatar}}
            <RelativeDate @date={{@topic.last_posted_at}} />
          </div>
        </a>
      </li>
      <li class="replies">
        {{number @topic.replyCount noTitle="true"}}
        <h4 role="presentation">{{i18n
            "replies_lowercase"
            count=@topic.replyCount
          }}</h4>
      </li>
      <li class="secondary views">
        {{number @topic.views noTitle="true" class=@topic.viewsHeat}}
        <h4 role="presentation">{{i18n
            "views_lowercase"
            count=@topic.views
          }}</h4>
      </li>
      {{#if (gt @topic.participant_count 0)}}
        <li class="secondary users">
          {{number @topic.participant_count noTitle="true"}}
          <h4 role="presentation">{{i18n
              "users_lowercase"
              count=@topic.participant_count
            }}</h4>
        </li>
      {{/if}}
      {{#if (gt @topic.like_count 0)}}
        <li class="secondary likes">
          {{number @topic.like_count noTitle="true"}}
          <h4 role="presentation">{{i18n
              "likes_lowercase"
              count=@topic.like_count
            }}</h4>
        </li>
      {{/if}}
      {{#if (gt this.linksCount 0)}}
        <li class="secondary links">
          {{number this.linksCount noTitle="true"}}
          <h4 role="presentation">{{i18n
              "links_lowercase"
              count=this.linksCount
            }}</h4>
        </li>
      {{/if}}

      {{#if this.shouldShowParticipants}}
        <li class="avatars">
          <TopicParticipants
            @participants={{slice 0 3 @topicDetails.participants}}
            @userFilters={{@userFilters}}
          />
        </li>
      {{/if}}
    </ul>
  
*/
{
  "id": "5zYyeAhv",
  "block": "[[[1,\"\\n    \"],[10,\"nav\"],[14,0,\"buttons\"],[12],[1,\"\\n      \"],[8,[32,0],[[24,0,\"btn\"]],[[\"@icon\",\"@title\",\"@ariaExpanded\",\"@ariaControls\",\"@action\"],[[30,0,[\"toggleMapButton\",\"icon\"]],[30,0,[\"toggleMapButton\",\"title\"]],[30,0,[\"toggleMapButton\",\"ariaExpanded\"]],[30,0,[\"toggleMapButton\",\"ariaControls\"]],[30,0,[\"toggleMapButton\",\"action\"]]]],null],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,\"ul\"],[12],[1,\"\\n      \"],[10,\"li\"],[14,0,\"created-at\"],[12],[1,\"\\n        \"],[10,\"h4\"],[14,\"role\",\"presentation\"],[12],[1,[28,[32,1],[\"created_lowercase\"],null]],[13],[1,\"\\n        \"],[10,0],[14,0,\"topic-map-post created-at\"],[12],[1,\"\\n          \"],[10,3],[14,0,\"trigger-user-card\"],[15,\"data-user-card\",[30,0,[\"createdByUsername\"]]],[15,\"title\",[30,0,[\"createdByUsername\"]]],[14,\"aria-hidden\",\"true\"],[12],[13],[1,\"\\n          \"],[1,[30,0,[\"createdByAvatar\"]]],[1,\"\\n          \"],[8,[32,2],null,[[\"@date\"],[[30,1,[\"created_at\"]]]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"li\"],[14,0,\"last-reply\"],[12],[1,\"\\n        \"],[10,3],[15,6,[30,1,[\"lastPostUrl\"]]],[12],[1,\"\\n          \"],[10,\"h4\"],[14,\"role\",\"presentation\"],[12],[1,[28,[32,1],[\"last_reply_lowercase\"],null]],[13],[1,\"\\n          \"],[10,0],[14,0,\"topic-map-post last-reply\"],[12],[1,\"\\n            \"],[10,3],[14,0,\"trigger-user-card\"],[15,\"data-user-card\",[30,0,[\"lastPosterUsername\"]]],[15,\"title\",[30,0,[\"lastPosterUsername\"]]],[14,\"aria-hidden\",\"true\"],[12],[13],[1,\"\\n            \"],[1,[30,0,[\"lastPostAvatar\"]]],[1,\"\\n            \"],[8,[32,2],null,[[\"@date\"],[[30,1,[\"last_posted_at\"]]]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"li\"],[14,0,\"replies\"],[12],[1,\"\\n        \"],[1,[28,[32,3],[[30,1,[\"replyCount\"]]],[[\"noTitle\"],[\"true\"]]]],[1,\"\\n        \"],[10,\"h4\"],[14,\"role\",\"presentation\"],[12],[1,[28,[32,1],[\"replies_lowercase\"],[[\"count\"],[[30,1,[\"replyCount\"]]]]]],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"li\"],[14,0,\"secondary views\"],[12],[1,\"\\n        \"],[1,[28,[32,3],[[30,1,[\"views\"]]],[[\"noTitle\",\"class\"],[\"true\",[30,1,[\"viewsHeat\"]]]]]],[1,\"\\n        \"],[10,\"h4\"],[14,\"role\",\"presentation\"],[12],[1,[28,[32,1],[\"views_lowercase\"],[[\"count\"],[[30,1,[\"views\"]]]]]],[13],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[28,[32,4],[[30,1,[\"participant_count\"]],0],null],[[[1,\"        \"],[10,\"li\"],[14,0,\"secondary users\"],[12],[1,\"\\n          \"],[1,[28,[32,3],[[30,1,[\"participant_count\"]]],[[\"noTitle\"],[\"true\"]]]],[1,\"\\n          \"],[10,\"h4\"],[14,\"role\",\"presentation\"],[12],[1,[28,[32,1],[\"users_lowercase\"],[[\"count\"],[[30,1,[\"participant_count\"]]]]]],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[41,[28,[32,4],[[30,1,[\"like_count\"]],0],null],[[[1,\"        \"],[10,\"li\"],[14,0,\"secondary likes\"],[12],[1,\"\\n          \"],[1,[28,[32,3],[[30,1,[\"like_count\"]]],[[\"noTitle\"],[\"true\"]]]],[1,\"\\n          \"],[10,\"h4\"],[14,\"role\",\"presentation\"],[12],[1,[28,[32,1],[\"likes_lowercase\"],[[\"count\"],[[30,1,[\"like_count\"]]]]]],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[41,[28,[32,4],[[30,0,[\"linksCount\"]],0],null],[[[1,\"        \"],[10,\"li\"],[14,0,\"secondary links\"],[12],[1,\"\\n          \"],[1,[28,[32,3],[[30,0,[\"linksCount\"]]],[[\"noTitle\"],[\"true\"]]]],[1,\"\\n          \"],[10,\"h4\"],[14,\"role\",\"presentation\"],[12],[1,[28,[32,1],[\"links_lowercase\"],[[\"count\"],[[30,0,[\"linksCount\"]]]]]],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"shouldShowParticipants\"]],[[[1,\"        \"],[10,\"li\"],[14,0,\"avatars\"],[12],[1,\"\\n          \"],[8,[32,5],null,[[\"@participants\",\"@userFilters\"],[[28,[32,6],[0,3,[30,2,[\"participants\"]]],null],[30,3]]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"]],[\"@topic\",\"@topicDetails\",\"@userFilters\"],false,[\"if\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/topic-map/topic-map-summary.js",
  "scope": () => [DButton, i18n, RelativeDate, number, gt, TopicParticipants, slice],
  "isStrictMode": true
}), _TopicMapSummary);